import { FC, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import SETTINGS from 'settings';
import {
  DEVELOP_INFO,
  getDevelopmentInfo,
  removeCookie,
  setCookie,
  setDevelopmentInfo,
} from './utils/cokisesUtil';
import { CloseIcon, LogoutIcon, ProfileIcon } from './icons';
import { fetchAuthToken } from 'core/services/WebApi';
import {
  getStorageDevelopMode,
  getStorageUserId,
  offStorageDevelopMode,
  onStorageDevelopMode,
} from 'utils';
import {
  getDomain,
  PATH_ACC_APPLICATION,
  PATH_ACC_LOAN_HISTORY,
  PATH_ACC_PERSONAL_INFORMATION,
  PATH_LOGIN,
  // PATH_REGISTRATION_STEP_1,
  // PATH_REGISTRATION_STEP_2,
  // PATH_REGISTRATION_STEP_3,
  // PATH_REGISTRATION_STEP_4,
  // PATH_REGISTRATION_STEP_5,
  // PATH_REGISTRATION_STEP_6,
  // PATH_REGISTRATION_STEP_7,
} from 'const';
import { history } from 'redux/store';
import { IApplication, ILoan } from 'redux/reducers/userApplications/type';

import './style.scss';

const PATHS_FOR_DEV = [
  '/login',
  // PATH_REGISTRATION_STEP_1,
  // PATH_REGISTRATION_STEP_2,
  // PATH_REGISTRATION_STEP_3,
  // PATH_REGISTRATION_STEP_4,
  // PATH_REGISTRATION_STEP_5,
  // PATH_REGISTRATION_STEP_6,
  // PATH_REGISTRATION_STEP_7,
  PATH_ACC_APPLICATION,
  PATH_ACC_LOAN_HISTORY,
  PATH_ACC_PERSONAL_INFORMATION,
];

export async function copyTokenToClipboard() {
  const token = fetchAuthToken() as string;
  if ('clipboard' in navigator) {
    return await navigator.clipboard.writeText(token);
  } else {
    return document.execCommand('copy', true, token);
  }
}

interface IDevelopmentInfo {
  removeAuthDataStorage: () => void;
  activeApplication?: IApplication;
  loan?: ILoan;
}

export const DevelopmentInfo: FC<IDevelopmentInfo> = (props) => {
  const { removeAuthDataStorage, loan, activeApplication } = props;

  const adminUrl = SETTINGS.apiPath?.slice(-1) === '/' ? SETTINGS.apiPath : SETTINGS.apiPath + '/';
  const [isOpen, setIsOpen] = useState(!getDevelopmentInfo());
  const [showPaths, setShowPaths] = useState(false);
  const [url, setUrlVal] = useState<string | null>('');

  const logOutHandler = () => {
    window.location.pathname = PATH_LOGIN;
    history.push(PATH_LOGIN);
    removeAuthDataStorage();
    window.location.reload();
  };

  const onOpen = () => {
    removeCookie(DEVELOP_INFO);
    setIsOpen(true);
  };

  const onClose = () => {
    setDevelopmentInfo('closed');
    setIsOpen(false);
  };
  const showPathsHandler = () => {
    setShowPaths((prev) => !prev);
  };

  const baseUrlHandler = (e: any) => {
    setUrlVal(e.target.value ? getDomain(e.target.value) : '');
  };

  const apiHandler = () => {
    logOutHandler();
    url && setCookie('dev_api_url', url, { expires: 7 });
  };

  const resetApiHandler = () => {
    logOutHandler();
    Cookies.remove('dev_api_url');
  };

  return isOpen ? (
    <div className="development-info flex-col">
      <div className="development-info__links">
        <LogoutIcon onClick={logOutHandler} className="development-info__icon fill" />
        <ProfileIcon onClick={showPathsHandler} className="development-info__icon fill" />
        <span>{SETTINGS.apiPath}</span>

        <CloseIcon
          className="development-info__icon development-info__close stroke"
          onClick={onClose}
        />
      </div>

      {showPaths && (
        <div className="paths">
          <span className="base-url__wrapper">
            <input
              className="base-url-input"
              defaultValue={SETTINGS.apiPath}
              onChange={baseUrlHandler}
            />
            <button style={{ background: '#d7c906', padding: '5px' }} onClick={apiHandler}>
              Set
            </button>
            <button style={{ background: 'pink', padding: '5px' }} onClick={resetApiHandler}>
              Reset
            </button>
          </span>
          <a
            href={`
            ${adminUrl}admin#/users/${getStorageUserId()}`}
            target="_blank"
            rel="noreferrer"
          >
            <span>user ID: {getStorageUserId()}</span>
          </a>
          <a
            href={`
            ${adminUrl}admin#/applications/${activeApplication?.id}/show`}
            target="_blank"
            rel="noreferrer"
          >
            <span>application ID: {activeApplication?.id}</span>
          </a>
          <a
            href={`
            ${adminUrl}admin#/loans/${loan?.id}/show`}
            target="_blank"
            rel="noreferrer"
          >
            <span>loan ID: {loan?.id}</span>
          </a>
          <button
            className="link"
            onClick={() => {
              if (getStorageDevelopMode()) {
                offStorageDevelopMode();
              } else {
                onStorageDevelopMode();
              }
              window.location.reload();
            }}
          >
            Develop mode: <b>{getStorageDevelopMode() ? 'ON' : 'OFF'}</b>
          </button>
          <button onClick={copyTokenToClipboard}> copy token</button>

          {PATHS_FOR_DEV.map((path) => (
            <NavLink key={path} to={path}>
              {path}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  ) : (
    <button type="button" className="development-info__empty" onClick={onOpen}>
      dev
    </button>
  );
};
